import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import WhiteButton from "../../common_components/common_button/WhiteButton";
import "./Step.css";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateBankDetail_Step3,
  GetStepsDetail,
} from "../../../features/admin/kycverification/kyc/Slice";
import { getUserId } from "../../../utils/authUser";

const user_id = getUserId();

const Step3 = ({ formData, setFormData, onNext, onBack }) => {
  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };
  const dispatch = useDispatch();

  const stepDetail = useSelector(
    (state) => state?.kycverification?.kyc?.stepdetail,
  );

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    dispatch(GetStepsDetail());
  }, [dispatch]);

  // useEffect(() => {
  //   const bankData = stepDetail?.kyc_bank_details;

  //   if (bankData) {
  //     setValue("account_holder_name", bankData.account_holder_name);
  //     setValue("bank_name", bankData.bank_name);
  //     setValue("account_no", bankData.account_no);
  //     setValue("ifsc_code", bankData.ifsc_code);
  //     setValue("upi_id", bankData.upi_id);
  //   }
  // }, [stepDetail, setValue]);

  const [isPrefilled, setIsPrefilled] = useState(false);

  useEffect(() => {
    const bankData = stepDetail?.kyc_bank_details;

    // No data
    if (!bankData) return;

    //  Already prefilled
    if (isPrefilled) return;

    // Don't prefill when KYC rejected
    const kycStatus = stepDetail?.kyc_identity_verification?.status?.toLowerCase();

    if (kycStatus === "rejected") {
      return;
    }

    setValue("account_holder_name", bankData.account_holder_name || "");

    setValue("bank_name", bankData.bank_name || "");

    setValue("account_no", bankData.account_no || "");

    setValue("ifsc_code", bankData.ifsc_code || "");

    setValue("upi_id", bankData.upi_id || "");

    setIsPrefilled(true);
  }, [stepDetail, setValue, isPrefilled]);



  const onSubmit = (data) => {
    const formDataObj = new FormData();

    formDataObj.append("user_id", user_id);
    formDataObj.append("account_holder_name", data.account_holder_name);
    formDataObj.append("bank_name", data.bank_name);
    formDataObj.append("account_no", data.account_no);
    formDataObj.append("ifsc_code", data.ifsc_code);
    formDataObj.append("upi_id", data.upi_id);

    dispatch(CreateBankDetail_Step3(formDataObj)).then((res) => {
      if (res?.payload) {
        onNext();
      }
    });
  };

  return (
    <section className="step1-section step3-section">
      {/* Title Section */}
      <div className="title-section">
        <h2 className="step1-title">Step 03: Bank / Payment Verification</h2>
        <p className="step1-subtitle">
          Add your bank or UPI details to receive your earnings without delay.
        </p>
      </div>

      {/* Form */}
      <div className="step1-form">
        <Form onSubmit={handleSubmit(onSubmit)}>
          {" "}
          <Form.Group className="mb-4">
            <Form.Label className="select_title">
              Account Holder Name
            </Form.Label>

            <Form.Control
              type="text"
              placeholder="eg. Sarah Jamdar"
              // ✅ Prevent numbers & symbols while typing
              onInput={(e) => {
                let value = e.target.value;

                // allow only alphabets + space
                value = value.replace(/[^A-Za-z\s]/g, "");

                // remove extra spaces
                value = value.replace(/\s+/g, " ");

                e.target.value = value;
              }}
              {...register("account_holder_name", {
                required: "Account holder name is required",

                pattern: {
                  value: /^[A-Za-z\s]+$/,
                  message: "Name should contain only letters",
                },

                minLength: {
                  value: 3,
                  message: "Name must be at least 3 characters",
                },

                validate: (value) => {
                  if (value.trim().length < 3) {
                    return "Name must be at least 3 characters";
                  }
                  return true;
                },
              })}
            />

            {errors.account_holder_name && (
              <Form.Text className="text-danger">
                {errors.account_holder_name.message}
              </Form.Text>
            )}
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label className="select_title">Bank Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="eg. State Bank of India"
              {...register("bank_name", {
                required: "Bank name is required",
                pattern: {
                  value: /^[A-Za-z\s]+$/,
                  message: "Bank name should contain only letters",
                },
                minLength: {
                  value: 3,
                  message: "Bank name must be at least 3 characters",
                },
              })}
            />

            {errors.bank_name && (
              <Form.Text className="text-danger">
                {errors.bank_name.message}
              </Form.Text>
            )}
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label className="select_title">Account Number</Form.Label>

            <Form.Control
              type="text"
              placeholder="eg. 123456789012"
              maxLength={18} // ✅ restrict max length while typing
              // ✅ Allow only digits
              onInput={(e) => {
                let value = e.target.value;

                // remove everything except numbers
                value = value.replace(/[^0-9]/g, "");

                e.target.value = value;
              }}
              {...register("account_no", {
                required: "Account number is required",

                pattern: {
                  value: /^[0-9]+$/,
                  message: "Account number must contain only digits",
                },

                minLength: {
                  value: 9,
                  message: "Account number must be at least 9 digits",
                },

                maxLength: {
                  value: 18,
                  message: "Account number cannot exceed 18 digits",
                },
              })}
            />

            {errors.account_no && (
              <Form.Text className="text-danger">
                {errors.account_no.message}
              </Form.Text>
            )}
          </Form.Group>
          <Row className="mb-4">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="select_title">IFSC Code</Form.Label>
                <Form.Control
                  type="text"
                  className="cap-latter"
                  placeholder="eg. SBIN0000456"
                  {...register("ifsc_code", {
                    required: "IFSC code is required",
                    pattern: {
                      value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                      message: "Enter a valid IFSC code",
                    },
                  })}
                />

                {errors.ifsc_code && (
                  <Form.Text className="text-danger">
                    {errors.ifsc_code.message}
                  </Form.Text>
                )}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="select_title">
                  UPI ID (optional)
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="eg. rahul@upi"
                  {...register("upi_id", {
                    pattern: {
                      value: /^[a-zA-Z0-9.\-_]{2,}@[a-zA-Z]{2,}$/,
                      message: "Enter a valid UPI ID",
                    },
                  })}
                />

                {errors.upi_id && (
                  <Form.Text className="text-danger">
                    {errors.upi_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </Col>
          </Row>
          {/* Warning text */}
          <p className="text-danger text-center fw-semibold">
            Ensure bank details are correct to avoid withdrawal failure.
          </p>
          {/* Buttons */}
          <div className="center-btn d-flex justify-content-center gap-3">
            <WhiteButton
              className="white-bt"
              title="Back"
              bg="#fff"
              color="#000"
              border="1px solid #000"
              onClick={onBack}
            />

            <WhiteButton
              title="Save"
              bg="#000"
              color="#f35f37"
              hoverBg="#000"
              hoverColor="#f35f37"
              type="submit"
            />
          </div>
        </Form>
      </div>
    </section>
  );
};

export default Step3;
